import type { Step } from "react-joyride";

export const auditRecordDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າລາຍລະອຽດບັນທຶກການກວດສອບ! ຫນ້ານີ້ຈະສະແດງຂໍ້ມູນລາຍລະອຽດຂອງບັນທຶກການກວດສອບ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="record-detail-header"]',
    content:
      "ນີ້ແມ່ນສ່ວນຫົວຂໍ້. ທ່ານຈະເຫັນຂໍ້ມູນພື້ນຖານຂອງບັນທຶກ, ຜົນການກວດສອບລວມ, ແລະປຸ່ມການກະທຳຕ່າງໆ ເຊັ່ນ ແກ້ໄຂ, ດາວໂຫຼດ PDF, ລຶບ, ຫຼືກັບໄປລາຍການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="record-detail-basic-info"]',
    content:
      "ນີ້ແມ່ນຂໍ້ມູນພື້ນຖານ. ທ່ານຈະເຫັນລາຍລະອຽດຂອງບັນທຶກ ເຊັ່ນ ຜະແນການກວດສອບ, ວັນທີ, ຜູ້ກວດສອບ, ຂອບເຂດ, ແລະອື່ນໆ.",
    placement: "top",
  },
  {
    target: '[data-tourid="record-detail-items"]',
    content:
      "ນີ້ແມ່ນລາຍການກວດສອບ. ທ່ານຈະເຫັນລາຍການກວດສອບທັງໝົດ, ຜົນການກວດສອບແຕ່ລະລາຍການ, ແລະໝາຍເຫດຖ້າມີ.",
    placement: "top",
  },
  {
    target: '[data-tourid="record-detail-summary"]',
    content: "ນີ້ແມ່ນສະຫຼຸບ. ທ່ານຈະເຫັນສະຫຼຸບຂອງການກວດສອບ ແລະຂໍ້ມູນເພີ່ມເຕີມຖ້າມີ.",
    placement: "top",
  },
];
